module.exports = __webpack_public_path__ + "img/389dcbd.jpg";